import { storageKeys } from "@/data/storageKeys";
import { Settings } from "@/shared/datastructures/Settings";

interface Priorities {
  priority1: string;
  priority1_color?: string;
  priority2: string;
  priority2_color?: string;
  priority3: string;
  priority3_color?: string;
  priority4: string;
  priority4_color?: string;
  priority5: string;
  priority5_color?: string;
}

export interface Priority {
  key: string;
  label: string;
  color: string;
  icon: string;
}

export class PrioritySettings extends Settings<Priorities> {
  protected get storageKey(): string {
    return storageKeys.priorities;
  }

  public getPriority(key: string): Priority | undefined {
    return this.allPriorities().find(p => p.key === key);
  }

  public allPriorities(): Priority[] {
    const settings = this.get();

    return [
      {
        key: "priority1",
        label: settings.priority1,
        icon: "looks_one",
        color: this.getColorSafe(settings.priority1_color, "priority_1")
      },
      {
        key: "priority2",
        label: settings.priority2,
        icon: "looks_two",
        color: this.getColorSafe(settings.priority2_color, "priority_2")
      },
      {
        key: "priority3",
        label: settings.priority3,
        icon: "looks_3",
        color: this.getColorSafe(settings.priority3_color, "priority_3")
      },
      {
        key: "priority4",
        label: settings.priority4,
        icon: "looks_4",
        color: this.getColorSafe(settings.priority4_color, "priority_4")
      },
      {
        key: "priority5",
        label: settings.priority5,
        icon: "looks_5",
        color: this.getColorSafe(settings.priority5_color, "priority_5")
      }
    ];
  }

  private getColorSafe(color: string | undefined | null, fallbackColor: string): string {
    const trimmedColor = color?.trim();
    const selectedColor = trimmedColor && trimmedColor !== "" ? trimmedColor : fallbackColor;

    if (selectedColor === "#ffffff") {
      return "#666666"
    }

    return selectedColor;
  }
}
